
class Attendance {
    constructor({
      id = null,
      nombre = '',
  
      fecha_hora = '',
      enroll_number = '',
        sucursal = '',
      cedula = '',
      empleado_id = '',
        tardanza_minutos,
    hora_entrada_permitida,
    hora_entrada_real
    }) {
      this.id = id;
      this.nombre = nombre;
      this.fecha_hora = fecha_hora;
 this.enroll_number = enroll_number;

      this.sucursal = sucursal;
     
    
      this.cedula = cedula;
      this.empleado_id = empleado_id;

   this.tardanza_minutos = tardanza_minutos;
    this.hora_entrada_permitida = hora_entrada_permitida;
    this.hora_entrada_real = hora_entrada_real;
     
    }
  
    // Método para actualizar los datos de la empresa
    update(data) {
      Object.assign(this, data);
    }
  }
  
  export default  Attendance;
  